<template>
  <b-modal
    title="Add Property Classification"
    ref="add-property-class-modal"
    id="add-property-class-modal"
    size="cu"
    ok-title="Confirm"
    class="custom-modal"
    @ok="confirm"
  >
    <div class="custom-prop container-fluid" style="font-family: NanumBarunGothic;">
      <div id="app">  
        <form class="apc" v-on:submit.prevent>
          <table class="table table-hover table-striped w-100">
            <thead>
              <tr class="table-active">
                <th style="width: 3%;"></th> 
                <th style="width: 14%; text-align: center;">Keyword</th> 
                <th style="width: 15%; text-align: center;">Property Group</th> 
                <th style="width: 15%; text-align: center;">Property</th> 
                <th style="width: 10%; text-align: center;">Value</th> 
                <th style="width: 10%; text-align: center;">AKA</th> 
                <th style="width: 10%; text-align: center;">Brand</th> 
                <th style="width: 10%; text-align: center;">Sub Brand</th> 
                <th style="width: 10%; text-align: center;">Product</th> 
                <th style="width: 3%;"></th> 
              </tr>
            </thead>
              
            <tbody>          
              <tr v-for="(item, index) in items">
                <td style="text-align: center;"> 
                  <feather-icon icon="PlusCircleIcon" size="20" stroke='#1817E7' @click="addPropCls"/>
                </td> 
                <td><input type="text" class="form-control" value="item.keyword" v-model="item.keyword"></td>
                <td>
                  <v-select 
                    :items="propGroupList" 
                    v-model="item.propGroupNm" 
                    dense 
                    outlined 
                    hide-details 
                    @change="propGroupChange(item)" 
                    style="font-size: 12px; text-align: center !important;"
                  />
                </td>
                <td>
                  <v-select 
                    :items="item.propList" 
                    v-model="item.propNm" 
                    dense 
                    outlined 
                    hide-details 
                    @change="propChange(item)" 
                    style="font-size: 12px; text-align: center !important;"
                  />
                </td> 
                <td><input type="text" class="form-control" value="item.value" v-model="item.value"></td>
                <td><input type="text" class="form-control" value="item.aka" v-model="item.aka"></td> 
                <td><input type="text" class="form-control" value="item.brandNm" v-model="item.brandNm" :disabled = !item.propIsTaste></td> 
                <td><input type="text" class="form-control" value="item.subBrandNm" v-model="item.subBrandNm" :disabled = !item.propIsTaste></td> 
                <td><input type="text" class="form-control" value="item.productNm" v-model="item.productNm" :disabled = !item.propIsTaste></td> 
                <td style="text-align: center;">
                  <feather-icon icon="DeleteIcon" size="20" stroke='#ea5455' @click="delPropCls(index)"/>
                </td> 
              </tr>  
            </tbody>
          </table>
        </form>   
      </div>
    </div>
  </b-modal>
</template>

<script>
import { 
  BCard, 
  BFormGroup, 
  BFormInput 
} from "bootstrap-vue";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import CISSettingService from '@/services/cis-setting.service';
import CategoryService from "@/services/category.service";

export default {
  name: "AddPropertyClassModal",
  components: {
    BCard,
    BFormGroup,
    BFormInput,
  },
  props: {
    token: {
      type: String,
      default: "",
    },
    refreshData: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      propGroupList: [],
      items:[], 
    };
  },
  watch: {
    token(newVal) {
      this.items = []
      this.addPropCls(newVal)
    },
  },
  methods: {
    async propGroupChange(item) {
      const response = await CISSettingService.getPropList(item.propGroupNm);

      if (response && response.status === 200) {
        item.propList = response.data.split(',');
      }
    },

    async propChange(item) {
      if (item.propNm === '맛')
        item.propIsTaste = true
      else
        item.propIsTaste = false
    },

    validation() {
      return new Promise((resolve, reject) => {
        var errMsg = '';
        var isValidate = true;

        if (this.items.length > 0) {


          for (const item of this.items) {
            if (item.propGroupNm === "") {
              isValidate = false;
              errMsg = "The Property Group field is required"
              break;
            }

            if (item.propNm === "") {
              isValidate = false;
              errMsg = "The Property field is required"
              break;
            }

            if (item.value === "") {
              isValidate = false;
              errMsg = "The Value field is required"
              break;
            }
          }
        }
        else {
          isValidate = false;
          errMsg = "There must be at least one property classification item"
        }

        if (!isValidate) {
          reject(errMsg);

          this.$toast({
            component: ToastificationContent,
            props: {
              title: errMsg,
              icon: "AlertCircleIcon",
              variant: "warning",
            },
          });
        }
        else 
          resolve(true);
      });
    },

    getCategoryIdx(data) {
      var catIdx = null;
      
      switch(data.propGroupNm.replace(/\s/g, '')) {
        case '공통속성':
          if (data.propNm === '맛')
            catIdx = 6;
          break;
        case '가격':
          if (data.propNm === '렌탈')
            catIdx = 3;
          break;
        case '구매후관리':
          if (data.propNm === '멤버쉽/회원')
            catIdx = 3;
          else if (data.propNm === '사용')
            catIdx = 9;
          break;
      }
      
      return catIdx;
    },

    async confirm(e) {
      e.preventDefault();

      await this.validation();

      this.$swal({
        title: "Are you sure?",
        html: `You want to add the property classification!<br>&nbsp;`,
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        padding: "1rem",
      }).then(async (result) => {
        if (result.isConfirmed) {

          var ctgSq = this.$store.getters.getSelectedCategory
          if(ctgSq == '9999'){
            ctgSq = 1
          }

          var category = 'Unknown';

          const catServResp = await CategoryService.getOneCategory(this.$store.getters.getSelectedCategory, null);

          if (catServResp.data.success)
            category = catServResp.data.data.title

          for (const item of this.items) {
            const dto = {
              category: category, 
              keyword: item.keyword, 
              property_group: item.propGroupNm.replace(/\s/g, ''), 
              property: item.propNm.replace(/\s/g, ''), 
              value: item.value, 
              aka: item.aka && item.aka.length > 0 ? item.aka.replace(/,/g, '|').replace(/\s/g, '') : null, 
              category_idx: this.getCategoryIdx(item), 
              brand: item.brandNm && item.brandNm.length > 0 ? item.brandNm.replace(/\s/g, '') : null, 
              line: item.subBrandNm && item.subBrandNm.length > 0 ? item.subBrandNm.replace(/\s/g, '') : null, 
              product: item.productNm && item.productNm.length > 0 ? item.productNm.replace(/\s/g, '') : null,
              ctgSq: ctgSq
            }

            const setServResp = await CISSettingService.insPropCls(dto);

            if (setServResp === null || setServResp.status !== 200) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: setServResp.data.message || "Unknown error",
                  icon: "AlertCircleIcon",
                  variant: "danger",
                },
              });
              break;
            }
          }

          this.$bvModal.hide("add-property-class-modal");
          this.refreshData();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Successfully added!`,
              icon: "EditIcon",
              variant: "success",
            },
          });
        }
      });
    },

    addPropCls(val) {
      var resToken = [''];

      if (typeof val === 'string' && val.length > 0)
        resToken = val.split(' ');

      for (const token of resToken) {
        this.items.push({
          propList : [],
          keyword : token,
          propGroupNm : '', 
          propNm :'', 
          value : '',
          aka : '',
          brandNm : '',
          subBrandNm : '',
          productNm : '',
          propIsTaste : false
        });
      }
    },

    delPropCls(index) {
      if (this.items > 1)
        this.items.splice(index,1)
      else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "최소 한개 이상의 속성 분류 항목이 존재해야 합니다.",
            icon: "AlertCircleIcon",
            variant: "warning",
          },
        });
      }

    }
  },
  async created() {
    const response = await CISSettingService.getPropGroupList();
    if (response && response.status === 200) {
      this.propGroupList = response.data.split(',');
    }
  },
};
</script>

<style>

.modal-cu {
  max-width: 1400px;
  margin: auto;
}

#add-property-class-modal .modal-body {
    padding: 0rem 0.8rem;
}

.apc .table {
  margin-bottom: 0rem;
}

.apc .table td {
  padding: 0.3rem 0.2rem;
}

.custom-prop .body {background-color: #000;}
.custom-prop {max-width: calc(1400px);padding: 0px;border-radius: 2px;}
.custom-prop .content td:first-of-type { width: 120px;}
.custom-prop .form-control {font-size: 11px;}
/* .custom-prop .groupName, .groupName:hover, .groupName:focus, .groupName:active {background-color: black; color: #888;border: none;outline: 0;} */

</style>